import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-carddebittrylogsmodal',
  templateUrl: './carddebittrylogsmodal.component.html',
  styleUrls: ['./carddebittrylogsmodal.component.css']
})
export class CarddebittrylogsmodalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
